import React from 'react';
import { Home } from './pages/Home';
import { RequestQuote } from './pages/RequestQuote';
import { ServiceContentPage, contentBreadcrumbs } from './pages/ServiceContentPage';
import { UtilityContentPage } from './pages/UtilityContentPage';
import { NotFound } from './pages/NotFound';
import { PageHead } from './components/pages/PageHead';
import { resolvePage } from './utils/routes';
import type { PageMetadata } from './types/pageContent';
export function App() {
  const route = typeof window === 'undefined' ? {
    kind: 'home' as const,
    path: '/'
  } : resolvePage(window.location.pathname, window.location.search);
  React.useEffect(() => {
    const numberedAliases: Record<string, string> = {
      '/10.html': '/commercial-truck-body-repair-services',
      '/18.html': '/make-a-payment',
      '/19.html': '/payment-login',
      '/26.html': '/trailer-and-rv-body-repair',
      '/33.html': '/isuzu-box-truck-roof-repair',
      '/34.html': '/about-motor-city-truck-collision'
    };
    const descriptivePath = numberedAliases[window.location.pathname];
    if (descriptivePath && route.kind === 'content') {
      window.history.replaceState(window.history.state, '', descriptivePath + window.location.search + window.location.hash);
    }
  }, [route.kind, route.path]);
  let content: React.ReactNode, metadata: PageMetadata;
  if (route.kind === 'home') {
    content = <Home data-id="element-0" data-mp="2zld0z6e9z99y" />;
    metadata = {
      title: 'Commercial Truck Collision Repair in Brighton MI | Motor City Truck Collision',
      description: 'Collision repair, bodywork and commercial painting for semis, box trucks, fleets and trailers in Brighton, Michigan. Call 248-986-8000 or request a quote.',
      path: '/',
      kind: 'home'
    };
  } else if (route.kind === 'quote') {
    content = <RequestQuote data-id="element-1" data-mp="3dm5zs3bm0qiv" />;
    metadata = {
      title: 'Request a Quote | Motor City Truck Collision',
      description: 'Tell the Brighton shop about your vehicle or equipment and the bodywork or painting needed. Photos are optional. This form is a client preview.',
      path: route.path,
      kind: 'quote',
      breadcrumbs: [{
        label: 'Home',
        path: '/'
      }, {
        label: 'Request a Quote',
        path: route.path
      }]
    };
  } else if (route.kind === 'content') {
    const page = route.page;
    content = ['service', 'guide', 'about'].includes(page.kind) ? <ServiceContentPage page={page} data-id="element-2" data-mp="d2biphy7dzw7" /> : <UtilityContentPage page={page} data-id="element-3" data-mp="851h73xjhxs0" />;
    metadata = {
      title: page.title,
      description: page.description,
      path: page.path,
      kind: page.kind,
      image: page.image,
      breadcrumbs: contentBreadcrumbs(page)
    };
  } else {
    content = <NotFound data-id="element-4" data-mp="3bnmh3mmdfd9x" />;
    metadata = {
      title: 'Page Not Found | Motor City Truck Collision',
      description: 'Find Motor City Truck Collision services, contact information and quote requests from the homepage.',
      kind: 'not-found'
    };
  }
  return <><PageHead metadata={metadata} data-id="element-5" data-mp="3liefgsns245r" />{content}</>;
}